import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BASEURL;

/**
 * Fetch all saved settings for a given user.
 */
export const fetchSavedSettingsByUser = createAsyncThunk(
    'savedSettings/fetchByUser',
    async ({userId}, {rejectWithValue}) => {
        try {
            const response = await axios.get(`${API_BASE}/api/internal/saved-settings/user/${userId}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

/**
 * Fetch all preset saved settings
 */
export const fetchPresets = createAsyncThunk(
    'savedSettings/fetchPresets',
    async (_, {rejectWithValue}) => {
        try {
            const response = await axios.get(
                `${API_BASE}/api/internal/saved-settings/presets`
            );
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

/**
 * Fetch a single saved settings entry by ID.
 */
export const fetchSavedSettingById = createAsyncThunk(
    'savedSettings/fetchById',
    async ({id}, {rejectWithValue}) => {
        try {
            const response = await axios.get(`${API_BASE}/api/internal/saved-settings/${id}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

/**
 * Create a new saved settings entry for a user.
 */
export const createSavedSetting = createAsyncThunk(
    'savedSettings/create',
    async ({userId, settings}, {rejectWithValue}) => {
        try {
            const response = await axios.post(
                `${API_BASE}/api/internal/saved-settings/user/${userId}`,
                settings
            );
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

/**
 * Update an existing saved settings entry for a user.
 */
export const updateSavedSetting = createAsyncThunk(
    'savedSettings/update',
    async ({userId, settings}, {rejectWithValue}) => {
        try {
            const response = await axios.put(
                `${API_BASE}/api/internal/saved-settings/user/${userId}`,
                settings
            );
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

/**
 * Delete a saved settings entry by ID.
 */
export const deleteSavedSetting = createAsyncThunk(
    'savedSettings/delete',
    async ({id}, {rejectWithValue}) => {
        try {
            await axios.delete(`${API_BASE}/api/internal/saved-settings/${id}`);
            return id;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);
